import SearchEmptyState from './SearchEmptyState';
import SearchEmptyStateContainer from './SearchEmptyState.container';

export default SearchEmptyStateContainer(SearchEmptyState);
